var map = {
	"./bkp/ar.json": 36767,
	"./bkp/ch.json": 27087,
	"./bkp/en.json": 19055,
	"./bkp/fr.json": 60172,
	"./bkp/gr.json": 91453,
	"./bkp/it.json": 75701,
	"./bkp/ru.json": 59193,
	"./bkp/sp.json": 79783,
	"./de.json": 71033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68185;